import { UserProfile, UserProfileJSON } from "models/UserProfile";
import { axiosInstance, network } from "./index";
import { LARAVEL_APP_HOST } from "../constants";

// The user profile api can handle all profile fields and some user fields
type UserProfileAPIJSONFields = UserProfileJSON & { phone?: string }

export class UserProfileAPI {
  static updateProfilePath = LARAVEL_APP_HOST + "/api/v1/update-user-profile";
  static getProfilePath = LARAVEL_APP_HOST + "/api/v1/user-profile";

  static async update(profile: UserProfileAPIJSONFields):Promise<boolean> {
    try {
      axiosInstance.post(this.updateProfilePath, profile)
      return true
    } catch(e) {
      console.error((e as any)?.message)
    }

    return false
  }

  static async get(): Promise<UserProfile> {
    const profileResponse = await network.callGet(this.getProfilePath, false);
    const myUserJSON = profileResponse?.data 
    const userProfile = UserProfile.fromJSON(myUserJSON)

    return userProfile
  }
}
